import { CatalogGiftReceivedStore, CatalogGiftArticleData } from '../../models/loyalty-catalog-gift-received-store.model';
import { Catalog } from 'app/models/promotion-catalog.model';
import { HttpClientService } from '../httpClient/httpclient.service';
import { ListMetadata } from '../../models/list-metadata.model';
import { Observable } from 'rxjs/Rx';
import { Injectable } from '@angular/core';
import { publishReplay, refCount } from 'rxjs/operators';

  @Injectable()
  export class LoyaltyCatalogGiftReceivedStoreService {
    baseUrl = HttpClientService.BASE_MS_LOYALTY;
    secondUrl = HttpClientService.BASE_MS_PROMO;
    cachedCatalogGiftFields: Observable<CatalogGiftReceivedStore>;
    cachedCatalogGiftItemFields: Observable<CatalogGiftReceivedStore>;
    cachedCatalogField: Observable<Catalog>;
    list_article: CatalogGiftArticleData[];
    userId: string;

    constructor(
      private http: HttpClientService
    ) { }



    /**
      * Tramite metodo GET, restituisce la lista dei Premi ricevuti, e nell'eventualità assegnati, da uno store.
      * Prevede obbligatoriamente un offset ed un limite, permettendo la paginazione della lista.
    */
     list(
      offset = null,
      limit = null,
      search?: Array<{ key: string, value: string }>,
      globalSearch?: string,
      sort?: string,
      sort_dir?: number
    ): Observable<{ data: Array<CatalogGiftReceivedStore>, metadata: ListMetadata }> {
      const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
      return this.http.getPaged(this.baseUrl + `/reservation/gift_head_rec?user_id=${this.userId}&param_all=true` +
        (params.toString() ? '&' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : '' ));
    }


    /**
     * Tramite metodo GET carico i campi del dto di GiftHeadReceived in un Observable
     * @returns il dto GiftHeadReceived
     */
    getCatlogGiftFields() {
      if (!this.cachedCatalogGiftFields) {
        this.cachedCatalogGiftFields = this.http.get(`${this.baseUrl}/schema/ReservationGiftHeadReceivedDto`).pipe(
          publishReplay(1), // this tells Rx to cache the latest emitted
          refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
        )
      }
      return this.cachedCatalogGiftFields;
    }

    /**
     * Tramite GET carico i campi del dto di GiftItemReceived in un Observable
     * @returns il dto GiftItemReceived
     */
    getCatlogGiftItemFields() {
      if (!this.cachedCatalogGiftItemFields) {
        this.cachedCatalogGiftItemFields = this.http.get(`${this.baseUrl}/schema/ReservationGiftItemReceivedDto`).pipe(
          publishReplay(1), // this tells Rx to cache the latest emitted
          refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
        )
      }
      return this.cachedCatalogGiftItemFields;
    }


    /**
     * Tramite GET carico i campi del dto di Catalog in un Observable
     * @returns il dto Catalog
     */
    getCatalogFields(){
      if (!this.cachedCatalogField) {
        this.cachedCatalogField = this.http.get(`${this.secondUrl}/schema/CatalogDto`).pipe(
          publishReplay(1), // this tells Rx to cache the latest emitted
          refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
        )
      }
      return this.cachedCatalogField;
    }

    /**
     * Metodo per ottenere il record di un Gift head received tramite id
     * @param giftId l'id del record che si vuole cercare
     * @returns i dati del record
     */
    getCatalogGiftData(giftId: number) {
      return this.http.get(`${this.baseUrl}/reservation/gift_head_rec?id=${giftId}`);
    }

    /**
     * Metodo per ottenere il record di un Gift item tramite id
     * @param giftId
     * @returns
     */
    getCatalogGiftItemData(giftId: number) {
      return this.http.get(`${this.baseUrl}/reservation/gift_item_rec?catalog_gift_itm_id=${giftId}&flg_state=0`);
    }

    /**
     * Chiamata GET per ottenere i Gift Types
     * @returns
     */
    getCatalogGiftTypes() {
      return this.http.get(`${this.baseUrl}/reservation/type`);
    }

    /**
     * Chiamata DELETE per eliminare un Catalog Gift
     * @param giftId
     * @returns
     */
    deleteCatalogGift(giftId: number) {
      return this.http.delete(`${this.baseUrl}/reservation/${giftId}`);
    }

    /**
     * Chiamata POST per creare un Gift Head Received, cioè le informazioni in testa di una ricezione
     * @param data
     * @returns
     */
    createReceivedCatalogGift(data: any) {
      return this.http.post(`${this.baseUrl}/reservation/gift_head_rec`, data);
    }

    /**
     * Chiamata PUT per modificare un Gift Head Received, le informazioni in testa di una ricezione
     * @param giftId l'id del record di Gift Head Received
     * @param data
     * @returns
     */
    updateCatalogGift(giftId: number, data: any) {
      return this.http.put(`${this.baseUrl}/reservation/gift_head_rec/${giftId}`, data);
    }

    /**
     * Chiamata POST per creare un Gift Item Received, cioè un articolo ricevuto in negozio con le relative informazioni
     * @param data
     * @returns
     */
    createCatalogGiftItem(data: any) {
      return this.http.post(`${this.baseUrl}/reservation/gift_item_rec`, data);
    }

    /**
     * Chiamata PUT per modificare un Gift Item Received, un articolo ricevuto in negozio con relative informazioni
     * @param giftItemId
     * @param data
     * @returns
     */
    updateCatalogGiftItem(giftItemId: number, data: any) {
      return this.http.put(`${this.baseUrl}/reservation/gift_item_rec/${giftItemId}`, data);
    }

    /**
     * Chiamata DELETE per eliminare un Gift Item Received a partire dal suo id
     * @param giftItemId l'id
     * @returns
     */
    deleteCatalogGiftItem(giftItemId: number) {
      return this.http.delete(`${this.baseUrl}/reservation/gift_item_rec/${giftItemId}`);
    }

    /**
     * Chiamata GET per ottenere i parametri di un determinato gruppo, in base alla lingua dell'utente
     * @param paramGroup il group param da ottenere
     * @param language la lingua dell'utente
     * @returns
     */
    getParamTypes(paramGroup: string, language: string) {
      return this.http.get(`${this.baseUrl}/params?param_group=${paramGroup}_${language}&sort=param_order&sort_dir=1`);
    }

    /**
     * Chiamata per la ricerca di un articolo, tramite il code o la descrizione
     * @param storeId l'id dello store
     * @param search il codice o la descrizione dell'articolo da cercare
     * @returns ritorna l'articolo o gli articoli che corrispondono alla ricerca, mappata la risposta per l'inserimento del/i record in un array di SelectItem
     */
    getGiftForReservationList(storeId: string, search){
      return this.http.get(`${this.baseUrl}/reservation/getGiftForReservationList?store_id=${storeId}&article_name=${search}`).map(res => res.map(r => ({label: `${r.catalog_gift_itm_code} - ${r.catalog_gift_description}`, value: `${r.catalog_gift_itm_code}`})));
    }

    /**
     * Chiamata per l'assegnazione premi di una determinata ricezione
     * @param storeId l'id dello store di cui si vuole assegnare i premi
     * @param data i dati
     * @returns
     */
    assignGift(storeId: string, reserv_gift_head_id: number, companyCode: number, data: any){
      return this.http.put(`${this.baseUrl}/reservation/assignGift?store_id=${storeId}&reservation_head_id=${reserv_gift_head_id}&flg_state=0&company_code=${companyCode}`, data)
    }

    /**
     * Chiamata per l'assegnazione premi di un determinato premio e di una determinata ricezione
     * @param storeId l'id dello store di cui si vuole assegnare i premi
     * @param data i dati
     * @returns
     */
     assignGiftSingle(storeId: string, reserv_gift_head_id: number, companyCode: number, catalog_item_code: any, data: any,){
      return this.http.put(`${this.baseUrl}/reservation/assignGift?store_id=${storeId}&reservation_head_id=${reserv_gift_head_id}&flg_state=0&company_code=${companyCode}&catalog_item_code=${catalog_item_code}`, data)
    }

    /**
     * Chiamata per recuperare i catalog relativi ad uno Store
     * @param storeId l'id dello store
     * @returns
     */
    getCatalogOfStore(storeId: string){
      return this.http.get(`${this.secondUrl}/catalog/getCatalogListByStore?store_id=${storeId}&flg_state=0`)
    }

    /**
     * Chiamata per l'invio della comunicazione ai clienti per il ritiro in negozio di uno o più articoli
     * @param storeId l'id dello store
     * @param search il codice o la descrizione dell'articolo da cercare
     * @returns ritorna l'articolo o gli articoli che corrispondono alla ricerca, mappata la risposta per l'inserimento del/i record in un array di SelectItem
     */
    sendCommunicationPickupReservationItem(storeId: string, reservation_head_id, listItemId){
      return this.http.get(`${this.baseUrl}/reservation/communicationPickupReservationItem?store_id=${storeId}&reservation_head_id=${reservation_head_id}&flg_state=0&list_itm_id=${listItemId}`);
    }
    /**
     * Chiamata per l'invio della comunicazione ai clienti per il ritiro in negozio di un articoli
     * @param storeId l'id dello store
     * @param search il codice o la descrizione dell'articolo da cercare
     * @returns ritorna l'articolo o gli articoli che corrispondono alla ricerca, mappata la risposta per l'inserimento del/i record in un array di SelectItem
     */
     sendCommunicationPickupReservationItemSingle(storeId: string, reservation_head_id, item_code : any, listItemId){
      return this.http.get(`${this.baseUrl}/reservation/communicationPickupReservationItem?store_id=${storeId}&reservation_head_id=${reservation_head_id}&flg_state=0&list_itm_id=${listItemId}&catalog_item_code=${item_code}`);
    }
  }



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-catalog-gift-received-store.service.ts